import { BufferGeometry } from "three";
import { setInterleavedBufferAttributes } from "../../../../assets/ts/three/utils/setInterleavedBufferAttributes";
export function createRing3DGeometry(innerRadius, outerRadius, thetaSegments, height, thetaStart, thetaLength, cap) {
    if (thetaStart === void 0) { thetaStart = 0; }
    if (thetaLength === void 0) { thetaLength = Math.PI * 2; }
    if (cap === void 0) { cap = false; }
    thetaSegments = Math.max(3, thetaSegments);
    var halfHeight = height * 0.5;
    // ------------------------------ Base Positions
    var basePositions = [];
    for (var i = 0; i <= thetaSegments; i++) {
        var index2 = i * 2;
        var rad = thetaStart + i / thetaSegments * thetaLength;
        basePositions[index2] = Math.cos(rad);
        basePositions[index2 + 1] = Math.sin(rad);
    }
    // ------------------------------ Vertices
    var vertices = [];
    // ---------- Forward / Back
    for (var i = 0; i < 2; i++) {
        var normalDir = i === 0 ? 1 : -1;
        var positionZ = normalDir * halfHeight;
        // ---------- Inner / Outer
        for (var j = 0; j < 2; j++) {
            var radius = j === 0 ? innerRadius : outerRadius;
            for (var k = 0; k <= thetaSegments; k++) {
                var index2 = (i === 0 ? k : thetaSegments - k) * 2;
                var x = radius * basePositions[index2];
                var y = radius * basePositions[index2 + 1];
                vertices.push(x, y, positionZ, 0, 0, normalDir);
            }
        }
    }
    // ---------- Inner / Outer
    for (var i = 0; i < 2; i++) {
        var normalDir = i === 0 ? -1 : 1;
        var radius = i === 0 ? innerRadius : outerRadius;
        // ---------- Forward / Back
        for (var j = 0; j < 2; j++) {
            var positionZ = (j === 0 ? 1 : -1) * halfHeight;
            for (var k = 0; k <= thetaSegments; k++) {
                var index2 = (i === 0 ? thetaSegments - k : k) * 2;
                var x = radius * basePositions[index2];
                var y = radius * basePositions[index2 + 1];
                vertices.push(x, y, positionZ, x * normalDir, y * normalDir, 0);
            }
        }
    }
    // ------------------------------ Indices
    var indices = [];
    for (var i = 0; i < 2; i++) {
        for (var j = 0; j < 2; j++) {
            var offset = (thetaSegments + 1) * (j * 2 + i * 4);
            for (var k = 0; k < thetaSegments; k++) {
                var index = k + offset;
                var a = index;
                var b = index + thetaSegments + 1;
                var c = b + 1;
                var d = a + 1;
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
    }
    // 断面にふたをする
    if (cap) {
        var x = void 0, y = void 0, a = void 0, b = void 0, c = void 0, d = void 0;
        x = basePositions[0];
        y = basePositions[1];
        vertices.push(x * innerRadius, y * innerRadius, halfHeight, y, -x, 0);
        vertices.push(x * innerRadius, y * innerRadius, -halfHeight, y, -x, 0);
        vertices.push(x * outerRadius, y * outerRadius, halfHeight, y, -x, 0);
        vertices.push(x * outerRadius, y * outerRadius, -halfHeight, y, -x, 0);
        x = basePositions[thetaSegments * 2];
        y = basePositions[thetaSegments * 2 + 1];
        vertices.push(x * innerRadius, y * innerRadius, halfHeight, -y, x, 0);
        vertices.push(x * innerRadius, y * innerRadius, -halfHeight, -y, x, 0);
        vertices.push(x * outerRadius, y * outerRadius, halfHeight, -y, x, 0);
        vertices.push(x * outerRadius, y * outerRadius, -halfHeight, -y, x, 0);
        a = (thetaSegments + 1) * 8;
        b = a + 1;
        c = a + 2;
        d = a + 3;
        indices.push(a, b, c);
        indices.push(c, b, d);
        a += 4;
        b = a + 1;
        c = a + 2;
        d = a + 3;
        indices.push(a, c, b);
        indices.push(b, c, d);
    }
    var geometry = new BufferGeometry();
    // geometry.boundingSphere = new Sphere(new Vector3(), 999999);
    geometry.setIndex(indices);
    setInterleavedBufferAttributes(geometry, vertices, 6, ['position', 'normal'], [3, 3]);
    return geometry;
}
